import { useEffect } from 'react';

import { useSelector } from 'react-redux';

const MetaPixelsEmbedder = () => {
  const gdprPreferences = useSelector(
    // @ts-ignore
    (state) => state.gdprPrivacyConsent?.preferences ?? {},
  );

  // Funzione per rimuovere gli script inseriti
  useEffect(() => {
    const metaPixelId = '154574680106226';
    const scriptId = 'meta-pixel-tracker-script';
    const noscriptId = 'meta-pixel-tracker-noscript';

    // Funzione per rimuovere gli script inseriti
    const removeMetaPixelsTracker = () => {
      const existingScript = document.getElementById(scriptId);
      const existingNoscript = document.getElementById(noscriptId);
      if (existingScript) existingScript.remove();
      if (existingNoscript) existingNoscript.remove();
      // @ts-ignore
      delete window._meta_pixel_id;
    };

    if (gdprPreferences.prof_META) {
      // Imposta la variabile globale
      // @ts-ignore
      window._meta_pixel_id = metaPixelId;

      // Evita duplicati
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.type = 'text/javascript';
        script.text = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window,document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '154574680106226');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
      }

      if (!document.getElementById(noscriptId)) {
        const noscript = document.createElement('noscript');
        noscript.id = noscriptId;
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none" alt=""
            src="https://www.facebook.com/tr?id=154574680106226&ev=PageView&noscript=1"
          />
          `;
        document.body.appendChild(noscript);
      }
    } else {
      // Se il consenso viene revocato
      removeMetaPixelsTracker();
    }

    return () => {
      removeMetaPixelsTracker();
    };
  }, [gdprPreferences.prof_META]);

  return null;
};

export { MetaPixelsEmbedder };
